<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-download"
          @click="downloadTemplate"
          v-if="permission.downloadTemplate"
          >下载模板
        </el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-upload2"
          @click="openUploadForm"
          v-if="permission.uploadBtn"
          >导入数据
        </el-button>
      </template>
    </avue-crud>

    <el-dialog
      title="食堂经营数据导入"
      append-to-body
      :visible.sync="showUploadDialog"
      width="555px"
    >
      <avue-form :option="excelOption" v-model="upload" :upload-after="uploadAfter"> </avue-form>
    </el-dialog>

    <!--<el-dialog-->
    <!--title="上传清单"-->
    <!--:visible.sync="showUploadDialog"-->
    <!--v-if="showUploadDialog"-->
    <!--:modal-append-to-body="false"-->
    <!--width="35%"-->
    <!--height="500px"-->
    <!--&gt;-->
    <!--<el-form ref="uploadForm" :model="upload" label-width="150px">-->
    <!--<el-row>-->
    <!--<el-col :span="20">-->
    <!--<el-form-item label="导入清单" prop="fileName">-->
    <!--<el-upload-->
    <!--accept=".xls"-->
    <!--limit="1"-->
    <!--style="display: inline-block; vertical-align: top;"-->
    <!--ref="upload"-->
    <!--action=""-->
    <!--:auto-upload="false"-->
    <!--:http-request="uploadImg"-->
    <!--:on-success="uploadImgSuccess"-->
    <!--:on-change="loadJsonFromFile"-->
    <!--:on-remove="handleRemove"-->
    <!--&gt;-->
    <!--<el-button size="small" type="primary">请选择文件</el-button>-->
    <!--</el-upload>-->
    <!--</el-form-item>-->
    <!--</el-col>-->
    <!--</el-row>-->
    <!--<el-row style="margin-bottom: 20px;">-->
    <!--<el-col offset="16">-->
    <!--<el-button-->
    <!--type="primary"-->
    <!--size="small"-->
    <!--icon="el-icon-check"-->
    <!--@click="uploadBill"-->
    <!--style="width: 72px; height: 36px;"-->
    <!--&gt;确认-->
    <!--</el-button>-->
    <!--<el-button-->
    <!--size="small"-->
    <!--@click="cancelUpload"-->
    <!--icon="el-icon-close"-->
    <!--style="width: 72px; height: 36px;"-->
    <!--&gt;取消-->
    <!--</el-button>-->
    <!--</el-col>-->
    <!--</el-row>-->
    <!--<el-row></el-row>-->
    <!--</el-form>-->
    <!--</el-dialog>-->
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  submitUploadBill,
} from '@/api/v4ward/demo/canteendailyreport';
import { mapGetters } from 'vuex';

export default {
  data() {
    const date = new Date();
    let defaultDateEnd = this.dayjs(date).format('YYYY-MM-DD');
    date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
    let defaultDateStart = this.dayjs(date).format('YYYY-MM-DD');

    return {
      excelOption: {
        submitBtn: false,
        emptyBtn: false,
        column: [
          {
            label: '数据上传',
            prop: 'excelFile',
            type: 'upload',
            drag: true,
            loadText: '数据上传中，请稍等',
            span: 24,
            propsHttp: {
              res: 'data',
            },
            tip: '请上传 .xls,.xlsx 标准格式文件',
            action: '/api/v4ward/canteenDailyReport/upload',
          },
        ],
      },
      showUploadDialog: false,
      upload: {
        fileName: '',
      },
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        sarchShow: true,
        searchMenuSpan: 6,
        calcHeight: 'auto',
        tip: false,
        border: true,
        index: true,
        viewBtn: true,
        editBtn: false,
        delBtn: false,
        selection: true,
        indexLabel: '序号',
        column: [
          {
            label: '食堂名称',
            prop: 'canteenName',
            labelWidth: 120,
            search: true,
            rules: [
              {
                required: true,
                message: '请输入食堂名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '食堂经营性质',
            prop: 'canteenType',
            search: true,
            searchLabelWidth: 100,
            labelWidth: 120,

            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=canteen_type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },

            rules: [
              {
                required: true,
                pattern: /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/,
                message: '请输入食堂经营性质',
                trigger: 'change',
              },
            ],
          },
          {
            label: '食材采购成本',
            prop: 'foodCost',
            labelWidth: 120,
            rules: [
              {
                required: true,
                pattern: /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/,
                message: '请输入食材采购成本，单位元，最多保留2位小数',
                trigger: 'change',
              },
            ],
          },
          {
            label: '煤气费',
            prop: 'gasFee',
            labelWidth: 120,
            rules: [
              {
                required: true,
                pattern: /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/,
                message: '请输入煤气费，单位元，最多保留2位小数',
                trigger: 'change',
              },
            ],
          },
          {
            label: '水费',
            prop: 'waterFee',
            labelWidth: 120,
            rules: [
              {
                required: true,
                pattern: /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/,
                message: '请输入水费，单位元，最多保留2位小数',
                trigger: 'change',
              },
            ],
          },
          {
            label: '电费',
            prop: 'electricityFee',
            labelWidth: 120,
            rules: [
              {
                required: true,
                pattern: /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/,
                message: '请输入电费，单位元，最多保留2位小数',
                trigger: 'change',
              },
            ],
          },
          {
            label: '人员成本',
            prop: 'peopleCost',
            labelWidth: 120,
            rules: [
              {
                required: true,
                pattern: /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/,
                message: '请输入人员成本金额，单位元，最多保留2位小数',
                trigger: 'change',
              },
            ],
          },
          {
            label: '其他费用',
            prop: 'otherFee',
            labelWidth: 120,
            rules: [
              {
                required: true,
                pattern: /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/,
                message: '请输入其他费用，单位元，最多保留2位小数',
                trigger: 'change',
              },
            ],
          },
          {
            label: '销售金额',
            prop: 'salesAmount',
            labelWidth: 120,
            rules: [
              {
                required: true,
                pattern: /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/,
                message: '请输入销售金额，单位元，最多保留2位小数',
                trigger: 'change',
              },
            ],
          },
          {
            label: '统计时间',
            prop: 'statisticsTime',
            searchLabelWidth: 100,
            labelWidth: 120,
            search: true,
            type: 'date',
            searchRange: true,
            startPlaceholder: defaultDateStart,
            endPlaceholder: defaultDateEnd,
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            rules: [
              {
                required: true,
                message: '请输入统计时间',
                trigger: 'change',
              },
            ],
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.canteendailyreport_add, false),
        viewBtn: this.vaildData(this.permission.canteendailyreport_view, false),
        delBtn: this.vaildData(this.permission.canteendailyreport_delete, false),
        editBtn: this.vaildData(this.permission.canteendailyreport_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    downloadTemplate() {
      const fileName = '食堂经营数据.xls';
      console.log('下载模板...');
      axios
        .get('/api/v4ward/canteenDailyReport/downloadTemp', { responseType: 'blob' })
        .then((res) => {
          let blob = new Blob([res.data], { type: 'application/download' });
          let downloadElement = document.createElement('a');
          downloadElement.href = window.URL.createObjectURL(blob); // 创建一个DOMString
          downloadElement.download = fileName;
          downloadElement.click();
          window.URL.revokeObjectURL(blob); // 释放 DOMString  ,解除内存占用
        })
        .catch((error) => {
          console.error(error);
        });
    },
    handleRemove(file, fileList) {
      console.log('移除文件...');
      console.log(file, fileList);
    },
    openUploadForm() {
      console.log('打开上传表单...');
      this.showUploadDialog = true;
    },
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    uploadAfter(res, done, loading, column) {
      this.showUploadDialog = false;
      this.upload.excelFile = '';
      this.refreshChange();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad(page) {
      debugger;
      page = page || this.page;
      let values = {
        ...this.query,
      };
      if (this.query.statisticsTime) {
        values = {
          ...this.query,
          statisticsTimeStart: this.query.statisticsTime[0],
          statisticsTimeEnd: this.query.statisticsTime[1],
        };
        values.statisticsTime = null;
      } else {
        const date = new Date();
        let defaultTimeEnd = this.dayjs(date).format('YYYY-MM-DD') + ' 00:00:00';
        date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
        let defaultTimeStart = this.dayjs(date).format('YYYY-MM-DD') + ' 00:00:00';

        values = {
          ...this.query,
          statisticsTimeStart: defaultTimeStart,
          statisticsTimeEnd: defaultTimeEnd,
        };
      }

      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, values)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
    loadJsonFromFile(file, fileList) {
      this.upload.fileName = file.name;
    },
    uploadImg(f) {
      var compareName = '食堂经营数据.xls';
      if (this.upload.fileName.substring(0, 10) !== compareName.substring(0, 10)) {
        this.$confirm('所选文件名与类型相差太多，是否确认无误？', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          this.uploadFile(f);
        });
      } else {
        this.uploadFile(f);
      }
    },
    uploadFile(f) {
      this.loading = true;
      const formData = new FormData();
      formData.append('file', f.file);
      submitUploadBill(formData)
        .then((response) => {
          if (response.code === 200) {
            this.$message.success('上传成功!');
            this.upload = {};
            this.refreshChange();
            this.showUploadDialog = false;
            this.loading = false;
          }
        })
        .catch(({ err }) => {
          f.onError();
          this.loading = false;
        });
    },
    uploadBill() {
      console.log('上传账单...');
      this.$refs.upload.submit();
    },
    cancelUpload() {
      console.log('取消上传...');
      this.upload = {};
      this.showUploadDialog = false;
      this.loading = false;
    },
  },
};
</script>

<style></style>
